/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'

/**
 * AuthSlice — holds in-flight state required to cross the route boundary
 * between IntroPage and VerifyPage.
 *
 * - verifyMode: which modal title/button label to show on VerifyPage
 * - email:      the address the user typed in EmailStep, consumed by OtpStep
 * - sessionId:  the cookieId established during validateUser, consumed by verifyCode
 *
 * Post-auth state (isLoggedIn, accountInfo, quoteInfo, etc.) lives in CommonSlice
 * as it always has — AuthSlice only holds what is needed before authentication completes.
 */

export const VERIFY_MODE = {
  NEW: 'new',
  CONTINUE: 'continue'
}

export const VERIFY_STEP = {
  EMAIL: 'email',
  OTP: 'otp',
  SUCCESS: 'success'
}

const initialState = {
  verifyMode: null,  // VERIFY_MODE.NEW | VERIFY_MODE.CONTINUE
  email: '',
  sessionId: ''
}

export const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setVerifyMode: (state, action) => {
      state.verifyMode = action.payload
    },
    setVerifyEmail: (state, action) => {
      state.email = action.payload
    },
    setVerifySessionId: (state, action) => {
      state.sessionId = action.payload
    },
    resetAuth: () => initialState
  }
})

export const {
  setVerifyMode,
  setVerifyEmail,
  setVerifySessionId,
  resetAuth
} = auth.actions

export default auth.reducer
